// extracted by mini-css-extract-plugin
export default {"actionsButtons":"TodosActions_actionsButtons__40I8Q","notActiveButton":"TodosActions_notActiveButton__8MT+o"};